/**
 * Rough material/labor cost index vs US national average (1.0).
 * Used only as a light adjustment on template fallback costs — not a substitute
 * for the contractor's own pricebook numbers.
 */
const STATE_MULTIPLIER: Record<string, number> = {
  AL: 0.92, AK: 1.18, AZ: 1.02, AR: 0.9, CA: 1.22,
  CO: 1.05, CT: 1.14, DE: 1.06, FL: 1.0, GA: 0.96,
  HI: 1.25, ID: 0.98, IL: 1.08, IN: 0.94, IA: 0.93,
  KS: 0.93, KY: 0.91, LA: 0.95, ME: 1.05, MD: 1.12,
  MA: 1.16, MI: 0.97, MN: 1.0, MS: 0.88, MO: 0.94,
  MT: 0.99, NE: 0.94, NV: 1.06, NH: 1.08, NJ: 1.15,
  NM: 0.96, NY: 1.18, NC: 0.95, ND: 0.97, OH: 0.96,
  OK: 0.92, OR: 1.1, PA: 1.04, RI: 1.1, SC: 0.94,
  SD: 0.93, TN: 0.93, TX: 0.98, UT: 1.0, VT: 1.06,
  VA: 1.02, WA: 1.12, WV: 0.9, WI: 0.97, WY: 0.98,
  DC: 1.14,
};

export function getRegionalCostMultiplier(stateCode?: string | null): number {
  if (!stateCode) return 1;
  const key = stateCode.trim().toUpperCase();
  return STATE_MULTIPLIER[key] ?? 1;
}

export function applyRegionalCost(baseCost: number, stateCode?: string | null): number {
  if (baseCost <= 0) return baseCost;
  const mult = getRegionalCostMultiplier(stateCode);
  return Math.round(baseCost * mult * 100) / 100;
}
